import main from '../views/main.vue'
import submain from '../views/subMain.vue'
import _ from 'lodash';

export const createRoute = (basePath, path, permission, component, title, icon, childrens?, showInMenu?) => {
    return {
        path: `/${basePath}`,
        name: basePath,
        permission: '',
        noSub: true,
        showInMenu: showInMenu,
        meta: { title },
        icon: icon,
        component: main,
        children: _.concat([
            { path: path, permission: permission, meta: { title }, name: path, component: component }
        ], childrens || [])
    }
}
export const createSubRoute = (path, permission, component, title, icon, showInMenu?) => {
    return {
        path: path, permission: permission,noSub:true, meta: { title }, name: path, component: component, icon: icon, showInMenu: showInMenu
    }
}
export const createRouteHasChildrens = (basePath, title, icon, childrens?,showInMenu?) => {
    return {
        path: `/${basePath}`,
        name: basePath,
        noSub: false,
        showInMenu: showInMenu,
        meta: { title },
        icon: icon,
        component: main,
        children: childrens || []
    }
}
export const createSubRouteHasChildrens = (path, title, icon, childrens?) => {
    return  {
        path: path,
        name: path,
        noSub:false,
        meta: { title },
        icon: icon,
        showInMenu: true,
        component:submain,
        children: childrens || []
    }
}
